<template>
  <div class="dsf-college-home full-view">
    <home-header
      :main-width="mainWidth"
      :dropdown-config="dropdownConfig"
      :custom-bts="customBts"
      :is-auto-hide-menu="isAutoHideMenu"
      @dropdown-click="$emit('dropdown-click', $event)"
    />
    <section class="dsf-college-home-section" :style="{'min-width': mainWidth + 20 + 'px'}">
      <div class="min-view" style="min-height:calc(100vh - 160px);">
        <router-view/>
      </div>
    </section>
    <footer class="dsf-college-home-footer">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
import HomeHeader from "./homeHeader.vue";

export default {
  name: "DsfCollegeHome",
  components: {
    HomeHeader
  },
  provide() {
    return {
      collegeRoot: this
    };
  },
  props: {
    mainWidth: {
      type: Number,
      default: 1200
    },
    dropdownConfig: {
      type: Array,
      default() {
        return [];
      }
    },
    logoUrl: {
      type: String,
      default: ""
    },
    searchPlaceholder: {
      type: String,
      required: true
    },
    // 未登录状态下自定义按钮
    customBts: {
      type: Array,
      default() {
        return [];
      }
    },
    clickBefore: {
      type: Function,
      required: false
    },
    doSearch: {
      type: Function,
      required: false
    },
    // 未匹配到菜单时，是否自动隐藏菜单
    isAutoHideMenu: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      height: "auto",
    };
  },
  methods: {
    loaded() {
      // this.loading = false;
      this.$nextTick(()=>{
        this.height = "auto";
        this.show = true;
      })
     
    },
    leaveHandler(el) {
      this.height = el.offsetHeight + "px";
    },
    _clickBefore(next, ...params) {
      if (this.isDesign) return;
      let res = this.clickBefore?.(...params);
      if (res && res.then) {
        res.then(r => {
          if (r !== false) {
            next(...params);
          }
        });
      } else if (res !== false) {
        next(...params);
      }
    }
  }
};
</script>